import { render, staticRenderFns } from "./xiaozi.vue?vue&type=template&id=02225282&scoped=true"
import script from "./xiaozi.vue?vue&type=script&lang=js"
export * from "./xiaozi.vue?vue&type=script&lang=js"
import style0 from "./xiaozi.vue?vue&type=style&index=0&id=02225282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02225282",
  null
  
)

export default component.exports